import {BasicButton} from '@packages/ui';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {appendQueryParam} from '../../../../../shared/services/appendQueryParam';

// リデザイン前のエントリーボタン
export const EntryButton: React.FC<{
  entryURL: string;
  sourceUrl?: string;
  isLarge?: boolean;
}> = ({entryURL, sourceUrl, isLarge = true}) => {
  const href = sourceUrl
    ? appendQueryParam(entryURL, 'source_url', sourceUrl)
    : entryURL;

  return (
    entryURL && (
      <div className={isLarge ? 'mt-16 pc:w-[60%] pc:mx-auto' : 'mb-8'}>
        <CommonLink href={href} passHref target="_blank">
          <BasicButton
            label="エントリーする"
            className={isLarge ? 'pc:h-[60px]' : 'pc:h-[40px]'}
            isPrimary={true}
            isLarge={isLarge}
          />
        </CommonLink>
      </div>
    )
  );
};
